const DEFAULT_LANG = "en_US";

const tg = {
  en_US: "https://t.me/xme_Global",
  zh_CN: "https://t.me/xme_Chinese",
  zh_TW: "https://t.me/xme_Chinese",
  vi_VN: "https://t.me/xme_Vietnam",
  // ru_RU: "https://t.me/xme_Russia",
  // ja_JP: "https://t.me/xme_Announcement",
  id_ID: "https://t.me/xme_Indonesian",
  ru_RU: "https://t.me/xme_Russia",
};

const x = {
  en_US: "https://x.com/xme_official_",
  zh_CN: "https://x.com/xme_ZH_",
  zh_TW: "https://x.com/xme_ZH_",
  ja_JP: "https://x.com/xme_JPN",
  vi_VN: "https://x.com/xme_VN",
};

const tiktok = "https://www.tiktok.com/@xme_gobal";
const medium = "https://medium.com/@xme_global";
const youtube = "https://www.youtube.com/@xme_GLOBAL";
const instagram = "https://www.instagram.com/voox_global/";
const linktree = "https://linktr.ee/VOOXGlobal";

function getSameAs(lang = DEFAULT_LANG) {
  return [
    tg[lang] || tg[DEFAULT_LANG],
    x[lang] || x[DEFAULT_LANG],
    tiktok,
    medium,
    youtube,
    // instagram,
    // linktree,
  ].filter(Boolean);
}

module.exports = {
  DEFAULT_LANG,
  tg,
  x,
  tiktok,
  medium,
  youtube,
  instagram,
  linktree,
  getSameAs,
};
